//External libs
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

//Local libs
import Service from 'src/app/common/service';
import DeviceHealthModel from './deviceHealthModel';

@Injectable({
  providedIn: 'root'
})
export class DeviceHealthService extends Service<DeviceHealthModel> {

  public ongoingRequests: Subscription[] = [];

  constructor(public httpClient: HttpClient) {
    super(httpClient, '/report/');
  }

  public deviceHealth() {
    return new Promise<Array<DeviceHealthModel>>((resolve, reject) => {
      const request = this.httpClient.get<Array<DeviceHealthModel>>(`${this.imagebaseUrl}${this.serviceUrl}deviceHealth`, this.httpOptions).subscribe(response => {
        resolve(response);
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  //To Cancel the onGoing Http Requests
  public cancelOnGoingHttpRequests(): void {
    this.ongoingRequests.forEach((request) => {
      if (request && typeof request.unsubscribe === 'function') {
        request.unsubscribe();
      }
    });
    this.ongoingRequests = [];
  }
}
